import { clsx } from 'clsx';
import { ReactNode } from 'react';

interface EntityListContainerHeaderProps {
  title: string;
  description: string;
  className?: string;
  endAdornment?: ReactNode;
}

export function EntityListContainerHeader({
  title,
  description,
  className,
  endAdornment
}: EntityListContainerHeaderProps) {
  return (
    <div className={clsx('d-flex justify-between align-items-center w-100', className)}>
      <div className={clsx('px-5 py-3')}>
        <h1 className='text-title-2'>{title}</h1>
        <div className='text-secondary mt-1'>{description}</div>
      </div>

      {endAdornment ? <div className='pr-5 py-3'>{endAdornment}</div> : null}
    </div>
  );
}
